// extracted by mini-css-extract-plugin
export default {"weatherContainer":"weatherApp_weatherContainer__6+8LW","title":"weatherApp_title__-3yu6"};